import React, { useCallback, useEffect, useState } from 'react'
import { Step, StepLabel, Stepper } from '@mui/material';
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton, LinearProgress, Tooltip } from "@mui/material";
import { Formik, Form } from 'formik'
import * as Yup from 'yup'
import FormikControl from '../../../components/FormikControl/FormikControl';
import OTPInput, { ResendOTP } from "otp-input-react";
import portalServices from '../portalService';

import dayjs, { Dayjs } from 'dayjs';

import ExpandableCard from '../../../components/ExpandableCard';
import CommonLoadingSkeleton from '../../../components/CommonLoadingSkeleton';
import { PersonPinCircle } from '@mui/icons-material';

import { Check, Event, Mail, Schedule, WorkOutline } from '@mui/icons-material';


export default function CheckIn({queueId,businessId, AppAlert}) {

    const [queueDetails,setQueueDetails] = useState(null);
    const [loading,setLoadingStatus] = useState(false);

    const [tokenDialogStatus, setTokenDialogStatus] = useState(false);
    const [checkInDetails,setCheckInDetails] = useState(null);

    const [savingInProgress, setSavingStatus] = useState(false);

    
    const [formValues, setFormValues] = useState(null);
    const [dialogStatus, setDialogStatus] = useState(false);
    const [selectedService, setSelectedService] = useState();

    const [checkInStatus,setCheckInStatus] = useState(false);
    const [watingTime,setWaitingTime] = useState(10);



    const getCheckinStatus = () =>{
        portalServices.getCheckInStatus(queueId).then(res=>{
            setCheckInStatus(true);
            setWaitingTime(res.waitingTime);
        }).catch(error=>{
            setCheckInStatus(false);
            AppAlert(error.msg)
        })
    }

    


    const initialValues = {
        serviceId:"",
        email:"",
        phone:"",
        customerToken:"",
        firstName:"",
        lastName:""
    }


    const validationRule = Yup.object({
        email:Yup.string().required("Required").email('Invalid email address'),
        customerToken:Yup.string().required("Required"),
        firstName:Yup.string().required("Required"),
        //lastName:Yup.string().required("Required"),
        phone:Yup.string()
        .required()
        .matches(/^[0-9]+$/, "Must be only digits")
        .min(10, 'Invalid Phone Number')
        .max(10, 'Invalid Phone Number')
    });


    const bookCheckInToken = (service)=>{
        
        let autoFill = {
            serviceId:"",
            email:"",
            phone:"",
            customerToken:"",
            firstName:"",
            lastName:""
        }
        setFormValues(autoFill);
        setActiveStep(0);
        setSelectedService(service);
        setOTPError(null);
        
        setDialogStatus(true)
    }



    const selectService = (service) =>{
        setSelectedService(service);
    }

    const onSubmit = (values, onSubmitProps) => {
        console.log("values",values)
        values['serviceId'] = selectedService.id;
        portalServices.doCheckin(values).then(res=>{
            AppAlert(res.msg);
            setDialogStatus(false);
            setCheckInDetails(res.checkInDetails);
            setOTPError("");
            setTokenDialogStatus(true);
        }).catch(error=>{
            setOTPError(error.msg);
            AppAlert(error.msg,"error");
        })

    }


    const [OTP, setOTP] = useState("");
    const [OTPError,setOTPError] = useState(null);

    const verifyOtp = (formik) =>{
            setOTPError(null)
            let data ={
                email:formik.values.email,
                businessId:businessId,
                queueId:queueId,
                serviceId:selectedService.id,
                otp:OTP
            };
            portalServices.verifyAppointmentEmailOTP(data).then(res=>{
                formik.setFieldValue("customerToken", res.data.token);
                //formik.setFieldTouched("customerToken");
                setActiveStep(activeStep => ++activeStep)
                AppAlert("OTP Verified");
            }).catch(error=>{
                setOTPError(error.msg);
                AppAlert(error.msg,"error");
            })

    }


    const requestEmailOTP = (formik) =>{
        if(!validateNext(formik) && activeStep < steps.length -1){
            console.log("email is",formik.values.email);
            let data ={
                email:formik.values.email,
                businessId:businessId,
            };
            portalServices.requestEmailOTP(data).then(res=>{
                setActiveStep(activeStep => ++activeStep)
                AppAlert("OTP Sent");
            }).catch(error=>{
                AppAlert(error.msg,"error");
            })
            //
        }
    }

    const resendOtp = (email) =>{
        let data ={
            email:email,
            businessId:businessId,
        };
        portalServices.resendOtp(data).then(res=>{
            AppAlert("OTP Sent");
        }).catch(error=>{
            AppAlert(error.msg,"error");
        })
    }

    const emailCheckInDetails =() =>{
        let data ={
            checkInId:checkInDetails.id,
        };
        portalServices.emailCheckInDetails(data).then(res=>{
            AppAlert("Email Sent");
        }).catch(error=>{
            AppAlert(error.msg,"error");
        })
    }


    

    const getQueueDetails = () =>{
        setLoadingStatus(true);
        portalServices.getPortalQueueDetails(queueId).then(res=>{
            setQueueDetails(res.data);
        }).catch(error=>{
            AppAlert(error.msg,"error")
        }).finally(()=>{
            setLoadingStatus(false);
        })
    }

    useEffect(()=>{
        getCheckinStatus();
        getQueueDetails();
    },[queueId])

    const getWeekDayName = (dayNo) =>{
        let weekDays = ["","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"]
        return weekDays[dayNo];
    }

    
    const handleClose  = () =>{
        setDialogStatus(false);
    }


    /*  Stepper Work  Start*/
    const [activeStep,setActiveStep] = useState(0);

    const steps = [
        ["email"],
        ["customerToken"],
        ["firstName","lastName" ],
    ]

    const validateNext = (formik) =>{
        let validationError = false;
        steps[activeStep].forEach(field => {
            formik.setFieldTouched(field);
            formik.validateField(field);
            if(formik.errors && formik.errors[field] !== undefined){
                validationError = true;
            }
        });
        return validationError;
    }

    const handleNext = (formik) =>{
        if(!validateNext(formik) && activeStep < steps.length -1){
            setActiveStep(activeStep => ++activeStep)
        }
    }

    const handlePrevious = (formik) =>{
        if(activeStep > 0){
            setActiveStep(activeStep => --activeStep)
        }
    }

    /*  Stepper Work  End*/


    const handleTokenDialogClose  = () =>{
        setTokenDialogStatus(false);
    }

    const getHumanTime =(time) =>{
        let temp = dayjs('2022-11-22T'+time)
        return temp.format("LT");
    }



    return (
        <>

            <Dialog
                  open={dialogStatus}
                  keepMounted
                  onClose={handleClose}
                  fullWidth={true}
                  /*maxWidth="md"*/
                  aria-describedby="alert-dialog-slide-description"
            >
  
                  <Formik
                      initialValues={formValues || initialValues}
                      validationSchema={validationRule}
                      onSubmit={onSubmit}
                      enableReinitialize validateOnMount
                  >
                      {
                          (formik) => {
                              //console.log(formik.values);
                              return (
                                  <Form>
                                        <DialogTitle>
                                            <div className="row p-2">
                                                <div className="col-md-12"> 
                                                    <Stepper activeStep={activeStep}>
                                                        <Step>
                                                            <StepLabel>Select Service</StepLabel>
                                                        </Step>
                                                        <Step>
                                                            <StepLabel>OTP Verification </StepLabel>
                                                        </Step>
                                                        <Step>
                                                            <StepLabel>Book My Appointment</StepLabel>
                                                        </Step>
                                                    </Stepper>
                                                </div>
                                            </div>
                                        </DialogTitle>
                                        <DialogContent>
                                          
                                            
                                            {activeStep === 0 && 
                                                <>
                                                    {queueDetails && queueDetails.queueBusinessServices.length > 0 &&
                                                        <>
                                                            <div className="row mt-4">
                                                                <div className="col-md-12 text-center">
                                                                    <h4>Select Service</h4>
                                                                </div>
                                                                <div className="col-md-12 text-center">
                                                                    {queueDetails.queueBusinessServices.map(service=>
                                                                        <span key={service.id}>
                                                                            {selectedService && service.id === selectedService.id ?
                                                                                <button type="button" className="btn btn-sm btn-dark m-2" onClick={()=>selectService(service)} > <Check/> {service.title} </button>
                                                                                :
                                                                                <button type="button" className="btn btn-sm btn-warning m-2" onClick={()=>selectService(service)} >{service.title} </button>
                                                                            }
                                                                        </span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </>
                                                    }

                                                    <div className="row mt-4">
                                                        <div className="text-center">
                                                            
                                                            <FormikControl control="input" formik={formik} type="text" 
                                                                label="Email" name="email" 
                                                                className="col-md-6"
                                                            />
                                                        </div>
                                                    </div>
                                                </>
                                            }

                                            {activeStep === 1 && 
                                                <>
                                                <div className="row mt-4">
                                                    <div className="col-md-12 text-center">
                                                        <h4>We have sent an otp on <br/> {formik.values.email}</h4>
                                                    </div>
                                                </div>
                                                <div className="row mt-2">
                                                    <div className="col-md-12 text-center">
                                                        <OTPInput value={OTP} onChange={setOTP} autoFocus OTPLength={6} otpType="number" disabled={false} style={{display:"block"}}  />
                                                    </div>
                                                    <div className="col-md-12">
                                                        <button type="button" className="btn btn-link float-end" onClick={()=>resendOtp(formik.values.email)} >Resend OTP</button>
                                                    </div>
                                                    <div className="col-md-12 text-center">
                                                        {OTPError && <h4 className="mt-3 text-danger">{OTPError}</h4>}
                                                    </div>
                                                </div>

                                                </>
                                            }


                                            {activeStep === 2 && 
                                                <>
                                                <div className="row mt-2">
                                                    <div className="col-md-12 text-center">
                                                        <h4>Your Details</h4>
                                                    </div>
                                                </div>
                                                <div className="row mt-2">
                                                    <div className="col-md-12 text-center">
                                                        <div className="row">
                                                            <div className="col-md-6">
                                                                <FormikControl control="input" formik={formik} type="text" 
                                                                    label="First Name" name="firstName"
                                                                />
                                                            </div>
                                                            <div className="col-md-6">
                                                            <FormikControl control="input" formik={formik} type="text" 
                                                                label="Last Name" name="lastName"
                                                            />
                                                            </div>
                                                            <div className="col-md-6">
                                                                <FormikControl control="input" formik={formik} type="text" 
                                                                    label="Phone" name="phone"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                </>
                                            }

    
                                            <div className="row">
                                            {  /* JSON.stringify(formik.values) */ }
                                            </div>
    
                                          
                                      </DialogContent>
                                      <DialogActions>
                                        {!savingInProgress && 
                                            <>
                                                <div className="col-md-12">
                                                    <button className="btn  float-end" type="button" onClick={handleClose}>Cancel</button>
                                                    
                                                    {activeStep > 0 && <button type="button" className="btn btn-primary float-start" onClick={() => handlePrevious()}>Back </button> }
                                                    {activeStep === 0 && <button type="button" className="btn btn-primary float-end" onClick={() => requestEmailOTP(formik)}>Continue </button>}
                                                    

                                                    {/* activeStep < steps.length -1 && activeStep !== 1 && <button type="button" className="btn btn-primary float-end" onClick={() => handleNext (formik)}>Next </button> */}
                                                    {activeStep === 1 && <button disabled={OTP.length < 6} type="button" className="btn btn-primary float-end" onClick={() => verifyOtp(formik)}>VerifyOtp </button> }

                                                    {activeStep === steps.length -1  &&
                                                        <button className="btn btn-success float-end" type="submit">Check In </button>
                                                    }

                                                </div>
                                            </>
                                        }
                                        
                                    </DialogActions>
                                  </Form>
                              )
                          }
                      }
                  </Formik>
              </Dialog>

            <Dialog
                  open={tokenDialogStatus}
                  keepMounted
                  onClose={handleTokenDialogClose}
                  fullWidth={true}
                  /*maxWidth="md"*/
                  aria-describedby="alert-dialog-slide-description"
            >
                {checkInDetails && 
                <>
                    <DialogTitle></DialogTitle>
                    <DialogContent>
                        
                        

                        <div className="row">
                            
                            <div className="offset-4 col-sm-4 mt-2">
                            {selectedService  && 
                                <div className="card bg-info text-center p-2">
                                    <span><WorkOutline/> </span>
                                    <span><strong>{checkInDetails.serviceTitle}</strong></span>
                                </div>
                            }
                            </div>
                        </div>

                        <div className="row mt-4">
                            <div className="col-md-6 text-center">
                                <h3>Token # : <strong>{checkInDetails.tokenPrefix}-{checkInDetails.id}</strong></h3>
                            </div>
                            <div className="col-md-6">
                                <h3>Booked for : <strong>{checkInDetails.firstName} {checkInDetails.lastName}</strong></h3>
                            </div>
                        </div>

                        <div className="row mt-4">
                            <div className="col-md-12 text-center text-primary">
                                <h3> Get check in details on </h3><button type="button" className="btn btn-success" onClick={emailCheckInDetails}> <Mail/> Email</button> 
                            </div>
                        </div>
                    </DialogContent>
                    <DialogActions> 
                        <button type="button" className="btn btn-light" onClick={handleTokenDialogClose}>Close</button> 
                        
                    </DialogActions>
                </>
                }
            </Dialog>

            <ExpandableCard title="Check In">
                <div className="card-body">
                    <div className="row">
                        <div className="col-md-12">
                            {loading && <CommonLoadingSkeleton /> }
                        </div>

                        {queueDetails && 
                            <>
                                <div className="col-md-12 text-center">
                                    <PersonPinCircle style={{fontSize:100}} />
                                </div>
                                {checkInStatus &&
                                    <div className="col-md-12 text-center text-danger">
                                        <span style={{fontSize:16}} className="badge bg-dark">Avg. Waiting Time {watingTime} minutes</span>
                                    </div>
                                }
                                {!checkInStatus &&
                                    <div className="col-md-12 text-center text-danger">
                                        <h3>Currently Closed</h3>
                                    </div>
                                }
                                {checkInStatus &&
                                    <div className="col-md-12 text-center">
                                        <h3 className="pt-3"> Select Service </h3>
                                        {queueDetails.queueBusinessServices.map(service=>
                                            <span key={service.id}>
                                                {selectedService && service.id === selectedService.id ?
                                                    <button type="button" className="btn btn-sm btn-dark m-2" onClick={()=>bookCheckInToken(service)} > <Check/> {service.title} </button>
                                                    :
                                                    <button type="button" className="btn btn-sm btn-warning m-2" onClick={()=>bookCheckInToken(service)} >{service.title} </button>
                                                }
                                            </span>
                                        )}
                                    </div>
                                }
                                
                            </>
                        }
                        
                    </div>
                </div>
            </ExpandableCard>
        </>
    )
}
